import React from "react";
import "./weekOverview.css";

import { Container, Row, Col } from "reactstrap";

const WeekOverview = props => {
  return (
    <div>
      <section className="week-overview pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col   sm={{ size: 5 }}>
              <h1 className="week-headline center-h1">Week Overview</h1>
            </Col>
          </Row>
          <Row className="justify-content-center text-left pt-5 pb-5">
          
            <Col sm={{ size: 10 }}>
              <p className="week-overview-text" >
                {props.subtext}
              </p>
            </Col>
          </Row>
          </Container>
        
          {props.children}
        
         
        
      </section>
    </div>
  );
};

export default WeekOverview;
